import React from 'react';
import Sidebar from '../Components/Sidebar/Sidebar';
import ChatGemini from '../../App/Components/ChatGemini/ChatGemini';
import { ensureProtocol } from '../../config/backend';
import './chat.css';

function ChatSolicitante() {
  const baseUrl = ensureProtocol(localStorage.getItem('ipBackend') || '');

  return (
    <div className="app-layout">
      <Sidebar />
      <main className="main-content">
        <div className="container-fluid tacoma-page chat-page">
          <div className="page-header tacoma-page-header">
            <h1 className="tacoma-page-title">Fale com Tacoma</h1>
            <p className="chat-page-subtitle">Tire dúvidas com o assistente. As respostas são em linguagem simples e amena.</p>
          </div>
          <div className="chat-page-content">
            <ChatGemini
              apiBaseUrl={baseUrl}
              chatPath="/api/chat-gemini"
              role="solicitante"
            />
          </div>
        </div>
      </main>
    </div>
  );
}

export default ChatSolicitante;
